import { render, staticRenderFns } from "./ShopCatalog.vue?vue&type=template&id=305e99c4"
import script from "./ShopCatalog.vue?vue&type=script&lang=js"
export * from "./ShopCatalog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports